import moment from "moment";
import { NumericFormat } from "react-number-format";
import defaultCard from "../../../../assets/images/default-card.png"
import { badge } from "src/utils/statusColorsCode";


export const CreatedDateColumnHandler = ({data}) => {
    const date=(data?.dataItem?.dateTime || data?.dataItem?.createdDate);
    return (
        <td>
            <div className="gridLink text-light-valueColor">
                {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
            </div>           
        </td>
    )
}
export const StatusColumnHandler = ({data}) => {
    const status = (data?.dataItem?.action ||data?.dataItem?.state)
    return (
        <td> <span className={`status-badge ${badge[status?.toLowerCase()] || 'bg-green'}`}>{status}</span></td>
    )
}
export const AmountColumnHandler = ({data}) => {
    const amount = (data?.dataItem?.amount)
    return (
        <td>
            {amount && <NumericFormat value={amount} decimalScale={2} thousandSeparator={true} thousandsGroupStyle='lakh' displayType='text'></NumericFormat>}
        </td>)
}


export const DateColumnHandler = ({data}) => {
    const date=(data?.dataItem?.date);
    return (
        <td>
            <div className="gridLink text-light-valueColor">
                {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
            </div>           
        </td>
    )
}

export const CardNumberColumnHandler = ({data}) => {
    const cardNumber=(data?.dataItem?.cardNumber);
    return (
        <td>
        {cardNumber !== null ? `XXXX XXXX XXXX ${cardNumber?.substr(-4)}` : 'XXXX XXXX XXXX XXXX'}
      </td>
    )
}

export const CardNameColumnHandler = ({data,customerDetailsHandler}) => {
    const cardName=(data?.dataItem?.cardName);
    return (
        <td onClick={() => customerDetailsHandler(data?.dataItem)}>
        <span className=' text-link cursor-pointer'>{cardName}</span>
      </td>
    )
}

export const CardLogoColumnHandler = ({data}) => {
    const logo=(data?.dataItem?.logo);
    return (
        <td>
        <img
          src={logo || defaultCard}
          alt='Card Logo'
          className='md:w-[80px] w-full h-full rounded-5 object-cover'
        />
      </td>
    )
}

export const FeeColumnHandler = ({data}) => {
    const fee = (data?.dataItem?.fee)
    return (
        <td>
            {fee && <NumericFormat value={fee} decimalScale={2} thousandSeparator={true} thousandsGroupStyle='lakh' displayType='text'></NumericFormat>}
        </td>)
}